(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog"]) return;
  try {
    

    $(document).ready(function ()
    {
    TJ.blog.init();
    })



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    



    $(document).ready(function ()
    {
    TJ.collection.init();
    })




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index_hero_slider"] && !Shopify.designMode) return;
  try {
    



    $(document).ready(function ()
    {
    TJ.hero.init();
    })




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-mystery"]) return;
  try {
    
    $(document).ready(function ()
    {
    TJ.pdp.init();
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
$(document).ready(function ()
{
TJ.pdp.init();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zpro_ti_blocks"] && !Shopify.designMode) return;
  try {
    



    $(document).ready(function ()
    {
    TJ.hero.init();
    })




  } catch(e) { console.error(e); }
})();
})();
